import { getHomeworks, uploadHomework } from './homework.actions'
import { IHomeworkState } from './homework.types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: IHomeworkState = {
    data: {
        total: 0,
        upcoming: 0,
        expired: 0,
        completed: 0,
        pending: 0,
        tasks: [],
        subjects: [],
    },
    isLoading: false,
    hasLoaded: false,
}

export const homeworkSlice = createSlice({
    name: 'student/homeworkSlice',
    initialState,
    reducers: {},
    extraReducers: {
        [getHomeworks.pending.type]: state => {
            state.isLoading = true
        },
        
        [getHomeworks.fulfilled.type]: (state, action: PayloadAction<any>) => {
            const data = action.payload
            
            state.isLoading = false
            state.hasLoaded = true
            state.data = data
        },
        
        [getHomeworks.rejected.type]: state => {
            state.isLoading = false
        },
        
        [uploadHomework.fulfilled.type]: (
            state,
            action: PayloadAction<number>,
        ) => {
            state.data.tasks = state.data.tasks.filter(task => {
                if (task.id === action.payload) {
                    task.status = 'На проверке'
                }
                
                return task
            })
            
            state.data.pending++
            state.data.upcoming--
        },
    },
})

export default homeworkSlice.reducer
